/**
 * @generated SignedSource<<3ade6b5d75b209565594fd17a5fc3766>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgAdminGeneralSaveMutation$variables = {
  setLogo?: string | null;
  setName?: string | null;
};
export type OrgAdminGeneralSaveMutation$data = {
  readonly organisation: {
    readonly update: {
      readonly id: string;
      readonly logo: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
      } | null;
      readonly name: string;
    } | null;
  };
};
export type OrgAdminGeneralSaveMutation = {
  response: OrgAdminGeneralSaveMutation$data;
  variables: OrgAdminGeneralSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "setLogo"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "setName"
},
v2 = [
  {
    "kind": "Variable",
    "name": "setLogo",
    "variableName": "setLogo"
  },
  {
    "kind": "Variable",
    "name": "setName",
    "variableName": "setName"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminGeneralSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrgMutation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Organisation",
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Image_image"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "OrgAdminGeneralSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OrgMutation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Organisation",
            "kind": "LinkedField",
            "name": "update",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbhash",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ImageSize",
                    "kind": "LinkedField",
                    "name": "sizes",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urlExpiresAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "height",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "width",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "453cf8ef8d665fae70cc61de9cf604c3",
    "id": null,
    "metadata": {},
    "name": "OrgAdminGeneralSaveMutation",
    "operationKind": "mutation",
    "text": "mutation OrgAdminGeneralSaveMutation(\n  $setName: String\n  $setLogo: String\n) {\n  organisation {\n    update(setName: $setName, setLogo: $setLogo) {\n      id\n      name\n      logo {\n        id\n        ...Image_image\n      }\n    }\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n"
  }
};
})();

(node as any).hash = "d421fa36df7d369623617fcea1fd692b";

export default node;
